module.exports = __webpack_public_path__ + "img/en.7c5ed6d8.svg";